import type { AdRequestBody, AdResponse } from './types.js';

/** Ad request transport. Picks fetch when available, falls back to XHR. */
export async function fetchAd(
  adServerUrl: string,
  body: AdRequestBody,
  signal?: AbortSignal,
): Promise<AdResponse> {
  const url = `${stripTrailingSlash(adServerUrl)}/v1/ad/request`;
  const res = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    credentials: 'omit',
    cache: 'no-store',
    keepalive: false,
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
    signal,
  });
  if (!res.ok) {
    throw new Error(`ad request failed: ${res.status}`);
  }
  return (await res.json()) as AdResponse;
}

/** Fire-and-forget GET, using sendBeacon when possible. */
export function pixel(url: string): void {
  if (!url) {
    return;
  }
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon(url);
      return;
    }
  } catch {
    // ignore, fall through
  }
  const img = new Image();
  img.referrerPolicy = 'no-referrer-when-downgrade';
  img.src = url;
}

function stripTrailingSlash(s: string): string {
  return s.endsWith('/') ? s.slice(0, -1) : s;
}
